module.exports = ".text-rigth {\n  text-align: right;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/retention/retention-list/retention-list.component.scss
// module id = ./src/app/system/retention/retention-list/retention-list.component.scss
// module chunks = main